/// <reference path="../../../../wwwroot/Scripts/kendo/kendo.all.d.ts" />

namespace PaperTrail.NewsletterControl {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class StoryWizardDialog extends Serenity.TemplatedDialog<any> {

        public selectedNewsletter: any;
        public selectedNewsletterId: any;

        private storyGUID: string;

        private enteredStoryTitle;
        private enteredStoryText;
        private enteredStoryImage;

        private storyRow: StoryRow;
        private storyImage: StoryImageRow;
        private uploadRequest: PaperTrail.NewsletterControl.ImageUploadRequest;


        constructor(opt: any) {
            super(opt);

            this.storyGUID = kendo.guid();

        }

        protected onDialogOpen() {
            super.onDialogOpen();


            Q.Router.replace("Wizard");

            let self = this;

            $(function () {
                $("#storyWizard").kendoWizard({
                    done: function (e) {
                        e.originalEvent.preventDefault();

                        var user = Q.Authorization.userDefinition
                        var userId = Administration.UserRow.getLookup().items
                            .filter(x => x.Username === user.Username)[0].UserId;

                        var storyTitle = $("#storyTitle").data("kendoTextArea");

                        var NewStory = <StoryContributorRow>{
                            UserId: userId,
                            NewsletterId: self.selectedNewsletterId,
                            DateSubmitted: kendo.toString(new Date(), "s"),
                            Title: storyTitle.value(),
                            StoryText: $("#storyText").val().replace(/(\r\n|\n|\r)/gm, ""),
                            NewslettersList: [self.selectedNewsletterId]
                        }
                        //debugger;
                        StoryService.Create({
                            Entity: NewStory
                        }, response => {
                            //debugger;
                            //Q.reloadLookup(StoryContributorRow.lookupKey);
                            //var newStory = Q.tryFirst(StoryContributorRow.getLookup().items, x => x.StoryId == response.EntityId);
                            //var storyImageUpload = upload.getFiles();
                            if (response.Error) {
                                Q.alert("Error: " + response.Error.Message)
                            }
                            else {
                                StoryImageService.CreateFromWizard({
                                    NewsletterId: self.selectedNewsletterId,
                                    StoryId: response.EntityId,
                                    GUID: self.storyGUID,
                                    UserId: userId
                                }, response => {
                                    if (response.Error) {
                                        Q.alert("Error: " + response.Error.Message)
                                    }
                                    else { 
                                        self.dialogClose();
                                        $(document).trigger("actionDone");  
                                    }
                                });
                            }

                        });
                    },
                    validateForms: true,
                    steps: [
                        {
                            title: "Start",
                            buttons: [{
                                name: "next"
                            }],
                            content: '<div>:You are about to submit a story to the following newsletter:</div><br/><div><p><b>' + self.selectedNewsletter.NewsletterName + '</b></p></div>'
                        },
                        {
                            title: "Title",
                            buttons: [{
                                name: "previous"
                            },
                            {
                                name: "next"
                            }],
                            form: {
                                formData: {
                                    StoryTitleGuidelines: "",
                                    StoryTitle: ""
                                },
                                items: [
                                    {
                                        field: "StoryTitleGuidelines",
                                        label: "",
                                        editor: function (container, options) {
                                            $("<div class='alert alert-info alert-dismissible'><button type='button' class='btn-close' data-bs-dismiss='alert' aria-hidden='true'></button><p>Give your story a title...</p></div>")
                                                .appendTo(container);
                                        },
                                        validation: { required: false }
                                    },
                                    {
                                        field: "StoryTitle",
                                        label: "Story Title",
                                        editor: function (container, options) {
                                            $("<input id='storyTitle'/>")
                                                .appendTo(container);
                                        },
                                        validation: { required: true }
                                    }
                                ]
                            }
                        },
                        {
                            title: "Text",
                            buttons: [{
                                name: "previous"
                            },
                            {
                                name: "next"
                            }],
                            form: {
                                formData: {
                                    StoryTextGuidelines: "",
                                    StoryText: "",
                                    StoryCharacters: "",
                                    StoryTextProgress: "",
                                    StoryTextProgressHint: ""
                                },
                                items: [
                                    {
                                        field: "StoryTextGuidelines",
                                        label: "",
                                        editor: function (container, options) {
                                            $("<div class='alert alert-info alert-dismissible'><button type='button' class='btn-close' data-bs-dismiss='alert' aria-hidden='true'></button><p>Now is the time to write your story...</p></div>")
                                                .appendTo(container);
                                        },
                                        validation: { required: false }
                                    },
                                    {
                                        field: "StoryText",
                                        label: "Story Text:",
                                        editor: function (container, options) {
                                            $("<textarea id='storyText' class='k-textarea' name='" + options.field + "' required data-bind='value: " + options.field + "'></textarea>")
                                                .appendTo(container);
                                        },
                                        validation: { required: true }
                                    },
                                    {
                                        field: "StoryCharacters",
                                        label: "",
                                        editor: function (container, options) {
                                            $("<div class='k-counter-container'><span class='k-counter-value'>0</span>&nbsp; characters</div>")
                                                .appendTo(container);
                                        },
                                        validation: { required: false }
                                    },
                                    {
                                        field: "StoryTextProgress",
                                        label: "",
                                        editor: function (container, options) {
                                            $("<div id='storyTextProgress'></div>")
                                                .appendTo(container);
                                        },
                                        validation: { required: false }
                                    },
                                    {
                                        field: "StoryTextProgressHint",
                                        label: "",
                                        editor: function (container, options) {
                                            $("<div id='storyTextProgressHint' class='storyTextProgressHint'></div>")
                                                .appendTo(container);
                                        },
                                        validation: { required: false }
                                    }
                                ]
                            }
                        },
                        {
                            title: "Image",
                            buttons: [{
                                name: "previous"
                            },
                            {
                                name: "next"
                            }],
                            form: {
                                formData: {
                                    StoryImageGuidelines: "",
                                    StoryImage: "",
                                    StoryImageDisplay: ""
                                },
                                items: [
                                    {
                                        field: "StoryImageGuidelines",
                                        label: "",
                                        editor: function (container, options) {
                                            $("<div class='alert alert-info alert-dismissible'><button type='button' class='btn-close' data-bs-dismiss='alert' aria-hidden='true'></button><p>If you feel like it, choose a photo to go along with your story...</p></div>")
                                                .appendTo(container);
                                        },
                                        validation: { required: false }
                                    },
                                    {
                                        field: "StoryImage",
                                        label: "Story Image:",
                                        editor: function (container, options) {
                                            $("<input name='storyImageUploader' id='storyImageUploader' type='file' aria-label='story image'/>")
                                                .appendTo(container);
                                        },
                                        validation: { required: false }
                                    },
                                    {
                                        field: "StoryImageDisplay",
                                        label: "",
                                        editor: function (container, options) {
                                            $("<div id='storyImageUploadDisplay'></div>")
                                                .appendTo(container);
                                        },
                                        validation: { required: false }
                                    }
                                ]
                            }
                        },
                        {
                            title: "Finish",
                            buttons: [{
                                name: "previous"
                            },
                            {
                                name: "done"
                            }],
                            content: '<h1>That\'s it you\'re done!  We will take care of the rest.</h1><br/><br/><br/><h3>Click "Done" to Submit your Story.</h3>'
                        }
                    ]
                });

                var storyTitle = $("#storyTitle").kendoTextArea({
                    placeholder: "Enter your story title here (max 30 characters)...",
                    rows: 1,
                    maxLength: 30
                    
                });

                // create TextArea from input HTML element
                var storyText = $("#storyText").kendoTextArea({
                    rows: 10,
                    placeholder: "Enter your story here..."
                });

                $("#storyText").on('input', function (e) {
                    $('.k-counter-container .k-counter-value').html($(e.target).val().length);

                    if ($(e.target).val().length < 400) {
                        storyTextProgress.value(0);
                        $('.storyTextProgressHint').html('you can do better...');
                    } else if ($(e.target).val().length <= 800) {
                        storyTextProgress.value(1);
                        $('.storyTextProgressHint').html('you can do a little better...');
                    } else if ($(e.target).val().length <= 1600) {
                        storyTextProgress.value(2);
                        $('.storyTextProgressHint').html('already here...');
                    } else if ($(e.target).val().length <= 2500) {
                        storyTextProgress.value(3);
                        $('.storyTextProgressHint').html('keep going...');
                    } else if ($(e.target).val().length <= 3500) {
                        storyTextProgress.value(4);
                        $('.storyTextProgressHint').html('not bad...');
                    } else if ($(e.target).val().length > 3500) {
                        storyTextProgress.value(5);
                        $('.storyTextProgressHint').html('ok enough...');
                    }
                });

                var storyTextProgress = $("#storyTextProgress").kendoProgressBar({
                    type: "chunk",
                    chunkCount: 5,
                    min: 0,
                    max: 5,
                    value: 0
                }).data("kendoProgressBar");
                
                var storyImageUploader = $("#storyImageUploader").kendoUpload({
                    validation: {
                        allowedExtensions: [".jpg", ".jpeg", ".png", ".PNG"],
                        maxFileSize: 1000000000
                    },
                    async: {
                        saveUrl: Q.resolveUrl("~/Services/Newsletter/StoryImage/WizardTemplUpload"),
                        removeUrl: Q.resolveUrl("~/Services/NewsletterControl/StoryImage/RemoveFromWizard"),
                        autoUpload: true
                    },
                    upload: function (e) {
                        self.uploadRequest = {} as PaperTrail.NewsletterControl.ImageUploadRequest;
                        self.uploadRequest.GUID = self.storyGUID
                        self.uploadRequest.DirectoryName = "StoryImageTemp"//create filehlper.ts to help get different paths (connects to new config section?) ** i think better to just send the "name" of the path how it is stored in web.config and then in upload service get it from web.config. later this "path name" can be a table and dynamically created.
                        e.data = self.uploadRequest;
                        //self.loadededBills = e.files;
                        //add csrf token to pass service call validation
                        var xhr = e.XMLHttpRequest;
                        var csrf = Q.getCookie("CSRF-TOKEN");
                        if (xhr) {
                            xhr.addEventListener("readystatechange", function onUploadReady(e) {
                                if (xhr.readyState == 1 /* OPENED */) {
                                    xhr.setRequestHeader("X-CSRF-TOKEN", csrf);
                                    xhr.removeEventListener("readystatechange", onUploadReady);
                                    // self.uploadBillsToSCS(e.files); 
                                }
                            });
                        }
                    },
                    success: onSuccess,
                    localization: {
                        select: "Select image file...",
                        dropFilesHere: "... Or drag & drop an image file here to upload"
                    }
                });

                var templateImageUpload = kendo.template($("#templateImageUpload").html());
                var initialFiles = [];

                $("#storyImageUploadDisplay").html(kendo.render(templateImageUpload, initialFiles));

                function onSuccess(e) {
                    if (e.operation == "upload") {
                        for (var i = 0; i < e.files.length; i++) {
                            var file = e.files[i].rawFile;

                            if (file) {
                                var reader = new FileReader();

                                reader.onloadend = function () {
                                    $("<div class='storyImageUpload'><img src=" + this.result + " /></div>").appendTo($("#storyImageUploadDisplay"));
                                };

                                reader.readAsDataURL(file);
                            }
                        }
                    }
                }

                function onSubmit(event) {
                    event.preventDefault();
                    //handle data submission
                }
            });
        }

        protected close() {
            let self = this;
            self.dialogClose();
        }

        protected onDialogClose() {
            super.onDialogClose();
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();

            return opt;
        }
    }
}